import axios from "axios";
import {API_URL, APP_URL} from "../config";

export const storeLocationService = async (values) => {
    return axios.post(`${API_URL}/locations`, {...values});
};

export const updateLocationService = async (values) => {
    return axios.put(`${API_URL}/locations/${id}`, {...values});
};

export const getLocationService = async (id) => {
    return axios.get(`${API_URL}/locations/${id}`);
}

export const listLocationsService = async (params) => {
    return axios.get(`${API_URL}/locations`, {
        params: {
            ...params
        }
    });
}
